import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DialogDelete from "../DialogDelete";
import { deleteRobot } from "../../components/robots/robotDetails/RobotInfo/service/service";
import { getType } from "../../components/robots/robotDetails/RobotInfo/reducer/reducer";
import { DELETE_ROBOT_INFO_SUCCESS } from "../../components/robots/robotDetails/RobotInfo/constant/constant";

class DialogRobotDelete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.open !== nextProps.open) {
      this.setState({
        open: nextProps.open,
      })
    }
    switch (nextProps.type) {
      case DELETE_ROBOT_INFO_SUCCESS:
        this.props.onSuccess();
        this.onClose();
        break;
    }
  }

  onClose() {
    this.setState({
      open: false,
    });
    this.props.onClose();
  }

  render() {
    const onClose = () => {
      this.onClose();
    };

    const onDeleteSubmit = () => {
      this.props.deleteRobot(this.props.uniqueCode);
    };

    return (
      <DialogDelete
        open={this.state.open}
        onClose={onClose}
        onDeleteSubmit={onDeleteSubmit}
        PaperProps={{
          className: "dialog dialog-sign-up"
        }}
      />
    );
  }
};

DialogRobotDelete.propTypes = {
  open: PropTypes.bool.isRequired,
  uniqueCode: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  type: getType(state.rootRobotsReducer.rootRobotDetailsReducer.robotDetailInfoReducer.type),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      deleteRobot,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DialogRobotDelete);
